export default __webpack_public_path__ + "static/media/JO.68a59996.svg";